// extracted by mini-css-extract-plugin
export default {"row":"_7f8ea54d","isMobile":"_ce6946bd","listItem":"_6170bed0","item":"_8e572652","link":"_53f2fc07","facebook":"_2da41fcf","pinterest":"_3ef4a0f1","instagram":"_9e30bebf"};